module.exports = __webpack_public_path__ + "static/media/random-news-paper.firebaseapp.com_(Laptop with MDPI screen).34808c83.png";